<template>
  <div
    class="day"
    :class="{'is-active': active}"
    @click="$emit('click', day)"
  >
    {{ day }}
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'Day',
  props: {
    date: {
      type: [Date, Object],
      default: new Date(),
    },
    active: Boolean,
  },
  computed: {
    day() {
      return dayjs(this.date).date();
    },
  },
};
</script>

<style lang="scss" scoped>
.day {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: solid 2px transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-h3);
  transition: 0.2s;
  cursor: pointer;
  &.is-active {
    border-color: var(--color-link);
  }
  &:hover {
    text-decoration: none;
    border-color: var(--color-link);
    background: var(--color-link);
    color: var(--color-light);
  }
}
</style>
